import React from 'react';
import { Link } from 'react-router-dom';

const FeaturesSection = () => {
  return (
    <section className="py-5 mb-5">
      <div className="container">
        <h2 className="section-title">Included Monthly Accounting Services</h2>
        <br />
        <div className="row">
          <div className="col-lg-4 mb-4 mb-lg-0">
            <Feature
              title="Tax Consultancy"
              description="Expert guidance to help you minimize tax liability, stay compliant, and plan smarter for the future."
            />
            <Feature
              title="Business Development & Strategic Planning"
              description="Helping your business grow with customized strategies and detailed planning support."
            />
          </div>
          <div className="col-lg-4 mb-3 mb-lg-0">
            <Feature
              title="Bookkeeping & Accounting"
              description="Accurate record-keeping and financial reporting to keep your business on track."
            />
            <Feature
              title="HR & Management Consultancy"
              description="Tailored solutions to optimize human resources and organizational efficiency."
            />
          </div>
          <div className="col-lg-4">
            <h6 className="text-gray font-os font-weight-semibold">
              IT Systems — Training & Support
            </h6>
            <ClientsCarousel />
          </div>
        </div>
      </div>
    </section>
  );
};

const Feature = ({ title, description, linkText = 'Find out More', linkUrl = '#!' }) => (
  <div className="feature-card d-flex flex-column justify-content-between h-50 p-2">
    <div>
      <h5>{title}</h5>
      <p className="text-dark">{description}</p>
    </div>
    <div>{/* <a href="/services" className="text-primary">{linkText}</a> */}</div>
  </div>
);

const ClientsCarousel = () => {
  const clients = ['1', '2', '3'];
  const items = [0]; // 3 carousel items

  return (
    <div
      id="landingClientCarousel"
      className="carousel slide landing-client-carousel"
      data-ride="carousel"
    >
      <div className="carousel-inner" role="listbox">
        {items.map((item, index) => (
          <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
            <div className="d-flex flex-wrap justify-content-center">
              {clients.map(client => (
                <div key={client} className="clients-logo">
                  <Link
                    target="_blank"
                    to="https://docs.google.com/forms/d/e/1FAIpQLSfOJu8ZO5lPNXmaASFaKiyPWUkHW-PHgZCsQ8bEA7SRlphIWA/viewform?usp=dialog"
                  >
                    <img
                      src={`assets/images/clients/${client}.png`}
                      alt={client}
                      className="img-fluid"
                    />
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <ol className="carousel-indicators">
        {items.map((_, i) => (
          <li
            key={i}
            data-target="#landingClientCarousel"
            data-slide-to={i}
            className={i === 0 ? 'active' : ''}
          ></li>
        ))}
      </ol>
    </div>
  );
};

export default FeaturesSection;
